export enum DiscountTypes {
  Percentage = "Percentage",
  Amount = "Amount",
}
